import { FunctionComponent } from 'react';
import {
  LIVE_VIDEO_CARD,
  useCardIsActive,
} from '@rsos/reduxDataStore/src/features/mapCard/mapCardSlice';
import { useVideoSessionInitialization } from '../useVideoSessionInitialization/useVideoSessionInitialization';
import {
  LiveVideoButton,
  StyledMeetingCameraIcon,
} from './LiveVideoButtonContainer.styles';

interface Props {
  onStartConversation: (message: string) => Promise<{ isSuccess: boolean }>;
}

export const LiveVideoButtonContainer: FunctionComponent<Props> = ({
  onStartConversation,
}) => {
  const { openVideoCall, sendVideoLink, videoCallStarted, role } =
    useVideoSessionInitialization({
      onStartConversation,
    });
  const videoOpen = useCardIsActive(LIVE_VIDEO_CARD);
  const buttonTextForRole = {
    viewer: 'Join Live Video',
    owner: 'Rejoin Live Video',
    none: 'Start Live Video',
  }[role || 'none'];

  return (
    <>
      <LiveVideoButton
        btnType="tertiary"
        grow
        noMargin
        onClick={openVideoCall}
        size="med"
        disabled={videoOpen}
        title={videoOpen ? 'Video is already active' : buttonTextForRole}
      >
        <StyledMeetingCameraIcon color="secondaryText" height={12} width={12} />
        {buttonTextForRole}
      </LiveVideoButton>
      {videoCallStarted && (
        <LiveVideoButton
          btnType="tertiary"
          grow
          noMargin
          onClick={sendVideoLink}
          size="med"
        >
          <StyledMeetingCameraIcon
            color="secondaryText"
            height={12}
            width={12}
          />
          Resend Video Link
        </LiveVideoButton>
      )}
    </>
  );
};
